import React from 'react';
import styles from './PaymentInvoice.module.css';

const STATUS_TAG = {
  GENERATED: { cls: styles.tGy, label: 'Generated' },
  SENT: { cls: styles.tTl, label: 'Sent to Venue' },
  PAID: { cls: styles.tGr, label: 'Paid' },
  OVERDUE: { cls: styles.tRd, label: 'Overdue' },
  DRAFT: { cls: styles.tAm, label: 'Draft' },
};

const fmtDate = iso => {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};

const fmtMoney = val => (val != null ? `$${Number(val).toFixed(2)}` : '$0.00');

const InvoiceHeader = ({ invoice }) => {
  const inv = invoice || {};
  const tag = STATUS_TAG[inv.status] || STATUS_TAG.GENERATED;
  const company = inv.company || {};

  const address = [
    company.addressLine1,
    company.city,
    company.state,
    company.postCode,
  ]
    .filter(Boolean)
    .join(', ');

  return (
    <div className={`${styles.invHeader} ${styles.card}`}>
      <div className={styles.invHeaderGrid}>
        {/* Left: KRAVEiN branding */}
        <div>
          <div className={styles.invLogo}>KRAVEiN</div>
          <div className={styles.invBrand}>
            Applause Technology Pty Ltd
            <br />
            ABN: 51 824 753 556
            <br />
            admin@kravein.com.au
          </div>
        </div>

        {/* Centre: Invoice identity */}
        <div className={styles.invCentre}>
          <div className={styles.invRemittance}>REMITTANCE ADVICE</div>
          <div className={styles.invNumber}>{inv.invoiceNumber || '—'}</div>
          <span className={`tag ${styles.tag} ${tag.cls}`}>{tag.label}</span>
          <div className={styles.invDates}>
            Period: {fmtDate(inv.period?.from)} – {fmtDate(inv.period?.to)} ·
            Due: {fmtDate(inv.paymentDate)}
          </div>
        </div>

        {/* Right: Venue info */}
        <div className={styles.invRight}>
          <div className={styles.invRemitTo}>Remittance to:</div>
          <div className={styles.invVenueName}>{company.name || '—'}</div>
          <div className={styles.invVenueDetails}>
            {company.abn && (
              <>
                ABN: {company.abn}
                <br />
              </>
            )}
            {address}
          </div>
        </div>
      </div>

      {/* Summary stat tiles */}
      <div className={styles.invStats}>
        <div className={styles.invStatTile}>
          <div className={styles.invStatLabel}>Orders</div>
          <div className={styles.invStatValue}>{inv.orderCount ?? 0}</div>
        </div>
        <div className={styles.invStatTile}>
          <div className={styles.invStatLabel}>Order Total</div>
          <div className={styles.invStatValue}>{fmtMoney(inv.orderTotal)}</div>
        </div>
        <div className={styles.invStatTile}>
          <div className={styles.invStatLabel}>Sale Value</div>
          <div className={styles.invStatValue}>{fmtMoney(inv.saleValue)}</div>
        </div>
        <div className={styles.invStatTile}>
          <div className={styles.invStatLabel}>KRAVEiN Fee</div>
          <div className={styles.invStatValue}>-{fmtMoney(inv.kraveinFee)}</div>
        </div>
        <div className={styles.invStatTile}>
          <div className={styles.invStatLabel}>Net Payout (incl. GST)</div>
          <div className={styles.invStatValue}>{fmtMoney(inv.netPayout)}</div>
        </div>
        <div className={styles.invStatTile}>
          <div className={styles.invStatLabel}>Application Fee</div>
          <div className={styles.invStatValue}>
            {fmtMoney(inv.applicationFee)}
          </div>
        </div>
        <div className={styles.invStatTile}>
          <div className={styles.invStatLabel}>Delivery Charge</div>
          <div className={styles.invStatValue}>
            {fmtMoney(inv.deliveryCharge)}
          </div>
        </div>
        <div className={styles.invStatTile}>
          <div className={styles.invStatLabel}>KRAVEiN Charge</div>
          <div className={styles.invStatValue}>
            {fmtMoney(inv.kraveinCharges)}
          </div>
        </div>
        <div className={styles.invStatTile}>
          <div className={styles.invStatLabel}>Kravein Payment Gateway Fee</div>
          <div className={styles.invStatValue}>
            {fmtMoney(inv.creditCardFee)}
          </div>
        </div>
        <div className={styles.invStatTile}>
          <div className={styles.invStatLabel}>KRAVEiN Payout</div>
          <div className={styles.invStatValue}>
            {fmtMoney(inv.kraveinPayout)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceHeader;
